import { Collapse, type CollapseProps } from "antd";
import { SvgArrowDown, SvgArrowUp } from "components/svg";
import { useGetVersionsQuery } from "store/api";
import useTranslation from "utils/hooks/useTranslation";

export const ChangeLogPage: React.FC = () => {
  const { language, convertToHtml } = useTranslation();
  const { data: VersionsData } = useGetVersionsQuery(null);

  const items: CollapseProps["items"] = (VersionsData as Array<VersionsData>)?.map((i: VersionsData) => ({
    key: i.id,
    label: i.version,
    children: <group data-direction="column" >{convertToHtml(language === 'fr' ? i.fr : i.en, '\n')}</group>,
  }));

  const changeLogList = <group data-direction="column">
    <Collapse items={items}
      expandIconPosition={"end"}
      expandIcon={({ isActive }) => (
        isActive ? <icon data-svg-size="70" data-min-length="70" data-svg-color="secondary"><SvgArrowUp /></icon> : <icon data-svg-size="70" data-min-length="70" data-svg-color="secondary"><SvgArrowDown /></icon>
      )}
    />
  </group>;

  return (
    <group>
      <group data-align="center" data-direction="column" data-gap="20">
        <group
          data-gap="40"
          //data-space-vertical="10"
          data-wrap="no"
          data-max-length="1440"
          data-adaptive="desktop"
        >
          {changeLogList}
        </group>
      </group>

      <group
        data-gap="40"
        //data-space-vertical="10"
        data-wrap="no"
        data-max-length="1440"
        data-adaptive="mobile"
        data-space-horizontal="20"
      >
        {changeLogList}
      </group>
    </group>
  );
};
